import React from 'react';
import styled from 'styled-components/native';
import CategoryHorizontalList from '../../components/CategoryHorizontalList';

const StyledContainer = styled.View`
  flex: 1;
  background-color: white;
  align-items: center;
  justify-content: center;
`;
const DiscoverCategoryListExampleScreen: React.FC = () => {
  return (
    <StyledContainer>
      <CategoryHorizontalList
        categories={['Sleep', 'Pain', 'Skin', 'Weight']}
      />
    </StyledContainer>
  );
};
export default DiscoverCategoryListExampleScreen;
